import { Typography } from "@mui/material";
import { Dialog } from "@progress/kendo-react-dialogs";
import { replaceNodesBreadcrumb } from "common/breadcrumb/store";
import EntaBackdrop from "common/components/EntaBackdrop";
import routes from "developer/routes";
import { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { fetchDeveloperForm } from "store/form/formDataSlice";
import { useAppDispatch, useAppSelector } from "store/hooks";
import { EditorModeTab } from "../constants";
import { clearFormEdited } from "../store/editorSlice";
import EditorGrid from "./EditorGrid";
import { isNotFound } from "common/api/utils/isNotFoundErrorAction";
import getQueryParamTenantId from "auth/utils/getQueryParamTenantId";

export default function Edit() {
  const { formDefinitionId } = useParams<{ formDefinitionId: string }>();
  const [tabSelected, setTabSelected] = useState<EditorModeTab>(
    EditorModeTab.VisualEditor
  );
  const history = useHistory();

  const dispatch = useAppDispatch();

  const formBeingEdited = useAppSelector(
    (state) => state.developer.edit.editor.formBeingEdited
  );

  const {
    isLoading,
    formDefinition,
    error: formDefinitionError,
    formDefinitionId: sharedFormToken,
  } = useAppSelector((state) => state.formData);

  const showFullscreen = useAppSelector(
    (state) => state.developer.edit.toolbar.showFullscreen
  );

  useEffect(() => {
    dispatch(
      replaceNodesBreadcrumb([
        { text: "Form Definitions", url: routes.FORM_DEFINITIONS },
        { text: formBeingEdited?.name || "" },
      ])
    );
  }, [dispatch, formBeingEdited?.name]);

  useEffect(() => {
    return () => {
      dispatch(clearFormEdited());
    };
  }, [dispatch]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        await dispatch(fetchDeveloperForm(formDefinitionId)).unwrap();
      } catch (error: any) {
        isNotFound(error) &&
          getQueryParamTenantId() != null &&
          history.push("/");
      }
    };

    fetchData();
  }, [dispatch, formDefinitionId, history]);

  if (sharedFormToken !== formDefinitionId || !formDefinition || isLoading) {
    return <EntaBackdrop isOpen={true} />;
  }

  if (formDefinitionError) {
    return (
      <Typography variant="subtitle2" color="error">
        {formDefinitionError}
      </Typography>
    );
  }

  if (showFullscreen)
    return (
      <Dialog width="100%" height="100%">
        <EditorGrid tabSelected={tabSelected} setTabSelected={setTabSelected} />
      </Dialog>
    );

  return (
    <EditorGrid tabSelected={tabSelected} setTabSelected={setTabSelected} />
  );
}
